// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2d8St","btn":"styles_btn__2D4bA","col":"styles_col__3sp0o","wrap":"styles_wrap__1jBnO","iconArrow":"styles_iconArrow__2Kq_6"};